<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
    </div>
    <div class="content">
      <div class="item">
        <h3>扫码取票</h3>
        <p>
          请将取票二维码
          对准扫码区
        </p>
        <img src=".././assets/q.png" alt class="img-qu" />
        <input type="text" id="qrcode2" v-model="qrcode2" class="qrcode2" />
      </div>
      <div class="item">
        <h3>取票码取票</h3>
        <p class="des">请输入取票码</p>
        <div class="input-wrapper">
          <input type="text" v-model="qrcode" maxlength="16" />
        </div>
        <div class="row">
          <span @click="getNum('1')">1</span>
          <span @click="getNum('2')">2</span>
          <span @click="getNum('3')">3</span>
        </div>
        <div class="row">
          <span @click="getNum('4')">4</span>
          <span @click="getNum('5')">5</span>
          <span @click="getNum('6')">6</span>
        </div>
        <div class="row">
          <span @click="getNum('7')">7</span>
          <span @click="getNum('8')">8</span>
          <span @click="getNum('9')">9</span>
        </div>
        <div class="row">
          <span @click="delelteNum">
            <i class="iconfont iconshanchu"></i>
          </span>
          <span @click="getNum('0')">0</span>
          <span
            @click="getSend"
            :disabled="qrcode.length>=16?false:true"
            :class="{'active':qrcode.length>=16}"
          >
            <i class="iconfont iconquerenduigougouhao"></i>
          </span>
        </div>
      </div>
    </div>
    <p class="tips">提示：如有问题请到服务台办理</p>
    <div class="footer">
      <div class="footer-tips">在下方扫码</div>
      <i class="iconfont iconxiangxia"></i>
      <p>
       <!-- 设备ID：{{deviceId}} -->
        <span class="tel">
          客服电话
          <span>25650850    25650860</span>
        </span>
      </p>
    </div>
    <div class="mask" v-if="warn!=''">
      <div class="mask-content">
        <div class="icon"></div>
        <p>{{warn}}</p>
      </div>
    </div>
    <div class="back" @click="goBack">后退</div>
  </div>
</template>

<script>
import { setInterval, clearInterval, setTimeout } from "timers";
export default {
  name: "Take",
  data() {
    return {
      warn: "",
      deviceId: localStorage.deviceNum||"123456789",
      time: "",
      today: "",
      timer: "",
      qrcode: "",
      qrcode2: ""
    };
  },
  mounted() {
    this.getDay();
    if (this.timer == "") {
      this.timer = setInterval(() => {
        this.getDay();
      }, 10000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  watch: {
    qrcode2(val) {
      if (val != "") {
        this.$api.TicketIn(this.qrcode2).then(res => {
          if (res.status == 1) {
            if (res.data.status == 2) {
              localStorage.movie = JSON.stringify(res.data);
              this.$router.push({
                path: "/detail"
              });
              this.$router.push({
                path: "/detail",
                query: {
                  id: res.data.order_id
                }
              });
            } else {
              this.warn = "该取票码已验证取票！";
              setTimeout(() => {
                this.warn = "";
                this.qrcode2 = "";
              }, 1500);
            }
          } else {
            this.warn = "您输入的取票码有误!";
            setTimeout(() => {
              this.warn = "";
              this.qrcode2 = "";
            }, 1500);
          }
        });
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getDay() {
      var day = new Date();
      var hours = day.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = day.getMinutes();
      min = min < 10 ? "0" + min : min;
      var month = day.getMonth() + 1;
      var days = day.getDate();
      var week = day.getDay();
      var strWeek = "";
      switch (week) {
        case 0:
          strWeek = "星期日";
          break;
        case 1:
          strWeek = "星期一";
          break;
        case 2:
          strWeek = "星期二";
          break;
        case 3:
          strWeek = "星期三";
          break;
        case 4:
          strWeek = "星期四";
          break;
        case 5:
          strWeek = "星期五";
          break;
        case 6:
          strWeek = "星期六";
          break;
      }
      this.time = hours + ":" + min;
      this.today = month + "月" + days + "日 " + strWeek;
    },

    //删除
    delelteNum() {
      this.qrcode = this.qrcode.substring(0, this.qrcode.length - 1);
    },
    getNum(num) {
      if (this.qrcode.length >= 16) {
        return false;
      }
      this.qrcode += num;
    },
    // 前往取票系统
    take() {
      this.$router.push("/take");
    },
    // 前往影院购票系统
    buy() {
      this.$router.push("/buy");
    },
    //打印门票
    getSend() {
      if (this.qrcode == "8888888888888888") {
        this.$router.push("/set");
        return false;
      }
      this.$api.TicketIn(this.qrcode).then(res => {
        if (res.status == 1) {
          if (res.data.status == 2) {
            localStorage.movie = JSON.stringify(res.data);
            this.$router.push({
              path: "/detail"
            });
          } else {
            this.warn = "该取票码已验证取票！";
            setTimeout(() => {
              this.warn = "";
              this.qrcode = "";
            }, 1500);
          }
        } else {
          this.warn = "您输入的取票码有误!";
          setTimeout(() => {
            this.warn = "";
            this.qrcode2 = "";
          }, 1500);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  width: 100%;
  min-height: 1920px;
  background: url(.././assets/buy_movie.png) no-repeat top center;
  overflow: hidden;
  position: relative;
  padding-bottom: 60px;
  .top {
    padding: 30px 32px;
    color: #fff;
    height: 564px;
    font-size: 25px;
    h3 {
      font-size: 70px;
      margin: 0;
    }
  }
  .titles {
    font-size: 92px;
    letter-spacing: 3px;
    color: #0c5193;
    text-align: center;
    margin: 131px;
  }
}
.qrcode2 {
  position: relative;
  z-index: -1;
  user-select: none;
  opacity: 0;
}
.content {
  padding: 0 60px;
  overflow: hidden;
  .item {
    width: 500px;
    float: left;
    border-radius: 6px;
    background-size: cover;
    &:first-child {
      margin-right: 60px;
      width: 390px;
      background-size: cover;
    }
    h3 {
      text-align: center;
      margin: 80px 0 60px;
      color: #005192;
      font-size: 40px;
      letter-spacing: 4px;
    }
    p {
      margin-top: 10px;
      text-align: center;
      color: #010101;
      font-size: 26px;
      line-height: 36px;
      width: 184px;
      margin: 0 auto;
      &.des {
        color: #8e8e8e;
        font-size: 30px;
      }
    }
    .img-qu {
      display: block;
      margin: 65px auto;
    }
    .input-wrapper {
      width: 490px;
      margin: 60px auto;
      height: 100px;
      border-radius: 50px;
      background: #cccccc;
      padding: 20px 30px;
      input {
        border: 0 none;
        outline: 0 none;
        display: block;
        width: 420px;
        margin: 10px auto;
        background: #cccccc;
        height: 40px;
        line-height: 40px;
        font-size: 38px;
        color: #010101;
        letter-spacing: 2px;
      }
    }
    .row {
      margin: 30px auto;
      width: 490px;
      span {
        width: 114px;
        height: 114px;
        display: inline-block;
        background: #ccc;
        border-radius: 50%;
        line-height: 114px;
        text-align: center;
        color: #434343;
        font-size: 48px;
        &:nth-child(2) {
          margin-left: 62px;
          margin-right: 62px;
        }
        &.active {
          background: #b95020;
          i {
            color: #fff;
          }
        }
        i {
          font-size: 48px;
          &.iconshanchu {
            display: inline-block;
            font-size: 30px;
            margin-top: -12px;
            vertical-align: middle;
          }
        }
      }
    }
  }
}
.tips {
  color: #aaa;
  text-align: center;
  font-size: 26px;
  line-height: 36px;
  margin: 30px auto;
  letter-spacing: 3px;
}
.back {
  width: 213px;
  height: 98px;
  line-height: 98px;
  box-shadow: 0px 4px 13px 0px rgba(185, 32, 80, 0.35);
  border-radius: 49px 0px 0px 49px;
  background: #fff;
  color: #b95020;
  font-size: 30px;
  text-align: center;
  position: fixed;
  bottom: 10%;
  right: 0;
  z-index: 998;
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 60px 60px 20px;
  font-size: 24px;
  width: 100%;
  background: #005192;
  .footer-tips {
    width: 210px;
    height: 210px;
    background: #0c5193;
    color: #fff;
    font-size: 22px;
    text-align: center;
    line-height: 120px;
    border-radius: 50%;
    position: absolute;
    top: -88px;
    left: 300px;
  }
  i {
    font-size: 40px;
    color: #fff;
    position: absolute;
    top: 0px;
    left: 370px;
  }
  p {
    color: #002f6f;
    font-size: 20px;
    overflow: hidden;
    vertical-align: middle;
    .tel {
      float: right;
      color: #fff;
      font-size: 20px;
      display: inline-block;
      vertical-align: bottom;
      span {
        margin-left: 10px;
        font-size: 34px;
        font-weight: 800;
        color: #fff;
      }
    }
  }
}
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  z-index: 999;
  transition: all ease-in-out 300ms;
  .mask-content {
    width: 600px;
    height: 384px;
    background: #fff;
    border-radius: 6px;
    padding: 65px;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .icon {
      width: 102px;
      height: 102px;
      background: url(.././assets/icon.png) no-repeat;
      background-size: cover;
      margin: 0 auto 80px;
    }
    p {
      color: #5c5c5c;
      font-size: 30px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Take.vue